// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2LmDD","checkboxCol":"Table_checkboxCol__2rv5X","emailCol":"Table_emailCol__1Mkn_","actionCol":"Table_actionCol__3KZmB"};